import type { AnsweredQuestion } from "@sveabank/cc-common";
import { BASE_PATH } from "..";
import type { SveaRequest } from "../../types/request";

export const fetchAmlQuestions: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/kyc/aml-v1`,
	method: "GET",
});

export const fetchQuestions: SveaRequest = (applicationId: string, questionIds: Array<string>) => ({
	url: `${BASE_PATH}/application/${applicationId}/kyc/questions-v1`,
	method: "GET",
	params: { questionIds: questionIds.join(",") },
});

export const postApplicationQuestions: SveaRequest = (
	applicationId: string,
	questions: Array<AnsweredQuestion>,
) => ({
	url: `${BASE_PATH}/application/${applicationId}/kyc/application`,
	method: "POST",
	body: {
		questions,
	},
});

export const postAmlQuestions: SveaRequest = (
	applicationId: string,
	productId: string,
	questions: Array<AnsweredQuestion>,
) => ({
	url: `${BASE_PATH}/application/${applicationId}/kyc/aml`,
	method: "POST",
	body: {
		productId,
		questions,
	},
});

export const fetchBeneficialOwner: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/beneficial-ownership`,
	method: "GET",
});

export const confirmBeneficialOwners: SveaRequest = (
	applicationId: string,
	beneficialOwnersConfirmed: boolean,
) => ({
	url: `${BASE_PATH}/application/${applicationId}/beneficial-ownership/confirm`,
	method: "POST",
	body: { beneficialOwnersConfirmed },
});

export const postBeneficialOwnerQuestions: SveaRequest = (
	applicationId: string,
	questions: Array<AnsweredQuestion>,
	beneficialOwnerQuestionKey: string,
) => ({
	url: `${BASE_PATH}/application/${applicationId}/kyc/beneficial-owner`,
	method: "POST",
	body: {
		nationalId: beneficialOwnerQuestionKey,
		questions,
	},
});

export const fetchSniCodes: SveaRequest = () => ({
	url: `${BASE_PATH}/application/sni-codes-v1`,
	method: "GET",
});

export const assignSniCodes: SveaRequest = (applicationId: string, sniCodes: Array<string>) => ({
	url: `${BASE_PATH}/application/${applicationId}/sni-codes`,
	method: "POST",
	body: { sniCodes },
});
